var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-container body-container" }, [
    _c("div", { staticClass: "project-top clearfix" }, [
      _c("div", { staticClass: "all-project", on: { click: _vm.gotoHome } }, [
        _vm._v("全部"),
      ]),
      _c("div", { staticClass: "thumb-project" }, [
        _c("img", {
          attrs: { src: _vm.getUrl(_vm.projectInfo.game_img), alt: "" },
        }),
        _c("span", [_vm._v(_vm._s(_vm.projectInfo.game_name))]),
      ]),
      _c(
        "div",
        { staticClass: "help-jump" },
        [
          _c("el-link", { attrs: { type: "primary", icon: "el-icon-info" } }, [
            _c("span", [_vm._v("帮助")]),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "project-img" }, [
          _c("img", {
            attrs: { src: _vm.getUrl(_vm.projectInfo.game_img), alt: "" },
          }),
        ]),
        _c("div", { staticClass: "project-info" }, [
          _c("h2", [_vm._v(_vm._s(_vm.projectInfo.game_name))]),
          _c("div", { staticClass: "project-info-box" }, [
            _c("span", { staticClass: "project-id" }, [
              _vm._v("ID：" + _vm._s(_vm.projectInfo.game_id)),
            ]),
            _c(
              "span",
              {
                staticClass: "project-setting",
                on: { click: _vm.gotoProjectInfo },
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/setting.svg"), alt: "" },
                }),
                _vm._v("项目设置"),
              ]
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "middle" },
        [
          _c("h3", [_vm._v("报告列表")]),
          Boolean(_vm.reportList.length)
            ? _c(
                "ul",
                { staticClass: "report-list" },
                _vm._l(_vm.reportList, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.inform_id,
                      class: {
                        active: _vm.selectReportId === item.inform_id,
                        "not-allowed":
                          item.inform_status === 2 || item.create_status === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectReport(item)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "li-icon",
                        attrs: { src: require("@/assets/report.svg"), alt: "" },
                      }),
                      _c("span", { staticClass: "list-text" }, [
                        _vm._v(_vm._s(item.inform_name)),
                      ]),
                      _c("em", [
                        item.inform_status === 1 && item.create_status === 0
                          ? _c("img", {
                              staticClass: "icon-status",
                              attrs: {
                                src: require("@/assets/wait.svg"),
                                alt: "",
                              },
                            })
                          : _vm._e(),
                        item.inform_status === 2
                          ? _c("img", {
                              staticClass: "icon-status",
                              attrs: {
                                src: require("@/assets/warn.svg"),
                                alt: "",
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("el-empty", { attrs: { description: "暂无报告" } }),
          _c("pagination", {
            attrs: {
              total: _vm.pageQuery.total,
              page: _vm.pageQuery.page,
              limit: _vm.pageQuery.limit,
              layout: "total, prev, pager, next",
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.pageQuery, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pageQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.pageQuery, "limit", $event)
              },
              pagination: _vm.getReportList,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "right" }, [
        _c("h3", [_vm._v("运行性能分析")]),
        _vm.selectReportId
          ? _c(
              "ul",
              { staticClass: "analysis-list" },
              _vm._l(_vm.reportNavList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: {
                      disabled:
                        !_vm.checkVipAllow(item.vipLevel) || item.disabled,
                    },
                    on: {
                      click: function ($event) {
                        _vm.gotoReport(
                          item.name,
                          !_vm.checkVipAllow(item.vipLevel) || item.disabled
                        )
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "li-icon",
                      attrs: { src: require("@/assets/analysis.svg"), alt: "" },
                    }),
                    _c("span", { staticClass: "list-text" }, [
                      _vm._v(
                        _vm._s(
                          item.meta.title + (item.disabled ? "(开发中)" : "")
                        )
                      ),
                    ]),
                    !_vm.checkVipAllow(item.vipLevel)
                      ? _c("em", { staticClass: "special" }, [
                          _vm._v("VIP" + _vm._s(item.vipLevel) + "开启"),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "empty" }, [_vm._v("暂无数据")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }